import axios from "axios";
import { crystalBaseUrl, defaultLang } from "@/config";

export default class AbstractService {
  constructor() {
    this.axios = axios.create(this.getAxiosConfig());
  }

  createAxios(config) {
    return axios.create(config);
  }

  getAxiosConfig() {
    return {
      baseURL: crystalBaseUrl(),
      headers: {
        "Accept-Language": defaultLang,
      },
      timeout: 30000,
      validateStatus: (status) => status >= 200,
    };
  }
}
